import _ from "lodash";
import axios from "axios";
import { DICT_KEY } from "@/constants/dict";
import { queryDictList } from "@/api/dict";
import { atob } from "js-base64";
import { getToken } from "@/utils/auth";
/**
 * 判断是否是数字
 */
export function checkFormNumber(rule, value, callback) {
  const numberVal = _.toNumber(value);
  if (_.isNaN(numberVal) || !_.isNumber()) {
    callback(new Error("请填写正确格式的数字"));
  } else {
    callback();
  }
}

/**
 * 判断是否是正整数
 */
export function checkFormPositiveInteger(rule, value, callback) {
  const numberVal = _.toNumber(value);
  if (_.isNaN(numberVal) || !_.isNumber(numberVal) || numberVal < 0) {
    callback(new Error("请填写正确格式的正整数"));
  } else {
    callback();
  }
}

/**
 * post请求的公共下载方法
 */
export function postDownload(url, data, name) {
  let token = getToken();
  console.log(token);
  const baseURL = "/api/storeroom";
  axios.post(baseURL + url, data, {
    responseType: "blob",
    headers: {
      'zh-Token': token,
      'Atomtoken': token
    }
  }).then((res) => {
    const reader = new FileReader();
    reader.readAsDataURL(res.data); // 转换为base64，可以直接放入a标签href
    reader.onload = (e) => {
      // 转换完成，创建一个a标签用于下载
      let a = document.createElement("a");
      a.style.display = "none";
      a.download = name;
      a.href = e.target.result;
      document.body.appendChild(a); // 修复firefox中无法触发click
      a.click();
      document.body.removeChild(a);
    };
  });
}


/**
 * 获取字典数据
 */
export function queryDict(type) {
  let dictList = [];
  queryDictList(DICT_KEY[type]).then((res) => {
    dictList = res.data || [];
    return dictList;
  });
  return dictList;
}

/**
 *
 * @param {*} dataUrl
 * @returns
 * @description 将base64转为blob
 */
const dataURLtoBlob = (dataUrl) => {
  let arr = dataUrl.split(","),
    mine = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new Blob([u8arr], { type: mine });
};

/**
 *
 * @param {*} theBlob
 * @param {*} fileName
 * @returns 文件
 * @description 将blob转为file
 */
const blobToFile = (theBlob, fileName) => {
  theBlob.lastModifiedDate = new Date(); // 文件最后修改日期
  theBlob.name = fileName;
  return new File([theBlob], fileName, {
    type: theBlob.type,
    lastModified: Date.now(),
  });
};

/**
 *
 * @param {*} file
 * @param {*} name
 * @returns {*} result
 * @description base64转文件函数
 */
export function base64ToFile(file, name) {
  // 1.base64转为blob
  // 2.blob转为文件
  return blobToFile(dataURLtoBlob(file), name);
}

/**
 *
 * @param {Object} target
 * @param {Object} source
 * @returns { Object }
 * @description 一般用于详情接口，后端返回对象中部分字段是不需要的
 * @description 仅赋值表单对象拥有的字段
 */
export function responseAssignFormData(target, source) {
  const result = { ...target }; // 深拷贝
  const targetKeys = Object.keys(target);
  const sourceKeys = Object.keys(source);

  targetKeys.forEach((key) => {
    if (sourceKeys.includes(key)) {
      result[key] = source[key];
    }
  });

  return result;
}
